import React from "react";
import {InnerTabsProps} from "./InnerTabs.props";
import {InnerTabsStyles} from "./InnerTabs.styles";

export const InnerTabs = ({...props}: InnerTabsProps): React.ReactElement => {
  return (
    <InnerTabsStyles defaultActiveKey="1" items={props.items} {...props}/>
  )
}